import { positions, Provider as AlertProvider, transitions } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
import React from "react";

type FPAlertProviderProps = {
  children: React.ReactNode;
};

const FPAlertTemplate = ({ message, options, style, close }) => {
  style = {
    width: undefined,
    maxWidth: "75%",
    minWidth: "300px",
    textAlign: "center",
    ...style,
  };
  return AlertTemplate({ message, options, style, close });
};

export const FPAlertProvider = ({ children }: FPAlertProviderProps) => {
  const options = {
    // you can also just use 'bottom center'
    position: positions.BOTTOM_CENTER,
    timeout: 5000,
    offset: "30px",
    // you can also just use 'scale'
    transition: transitions.SCALE,
    containerStyle: {
      zIndex: 10000,
    },
  };

  return (
    <AlertProvider template={FPAlertTemplate} {...options}>
      {children}
    </AlertProvider>
  );
};
